import React from "react";
import PropTypes from "prop-types";

export const alignmentValues = [
  "left",
  "center",
  "left-center",
  "center-left",
] as const;

export type AlignmentValue = typeof alignmentValues[number];

export type HeadContextType = {
  alignment?: AlignmentValue;
};

export const HeadContext = React.createContext<HeadContextType | undefined>(
  undefined
);

type HeadContextProps = {
  children: React.ReactNode;
  alignment?: AlignmentValue;
};

export const HeadProviderDefaultProps = {
  alignment: "center",
} as const;

export const HeadProvider = ({
  children,
  alignment = HeadProviderDefaultProps.alignment,
}: HeadContextProps): JSX.Element => {
  const value = { alignment };
  return <HeadContext.Provider value={value}>{children}</HeadContext.Provider>;
};

HeadProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  alignment: PropTypes.oneOf(alignmentValues),
};

HeadProvider.defaultProps = {
  alignment: HeadProviderDefaultProps.alignment,
};
export const useHead = (): HeadContextType | never => {
  const context = React.useContext(HeadContext);

  if (context === undefined) {
    throw new Error("useHead must be used within a HeadProvider");
  }

  return context;
};
